import { IconButton } from '@material-ui/core';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import TrashIcon from '@svg/trash.svg';
import React from 'react';
import styled from 'styled-components';

const StyledIconButton = styled(IconButton)<{
  $isErrorTextShown: boolean;
  $isVisible: boolean;
}>`
  align-self: ${({ $isErrorTextShown }) =>
    $isErrorTextShown ? 'center' : 'auto'};
  min-width: 2rem;
  margin-bottom: 0.2rem;
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};

  svg {
    fill: ${({ theme }) => theme.colors.darkRed};
    stroke: ${({ theme }) => theme.colors.darkRed};
  }
`;

interface DeleteConditionalPropertyButtonProps {
  remove: () => void;
  label: string;
  $isVisible: boolean;
  $isErrorTextShown: boolean;
}

export function DeleteConditionalPropertyButton({
  remove,
  label,
  $isVisible,
  $isErrorTextShown,
}: DeleteConditionalPropertyButtonProps) {
  return (
    <StyledIconButton
      onClick={remove}
      color="secondary"
      $isErrorTextShown={$isErrorTextShown}
      $isVisible={$isVisible}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      <TrashIcon aria-hidden />
    </StyledIconButton>
  );
}
